import type { ApiShopperLandingPage } from '@storefronts/common-types'

export type OpenGraphTag = { property: string; content: string }

/**
 * Open Graph tags Meta's crawlers read for link previews. `og:url` is deliberately omitted:
 * the storefront is served under a merchant-customizable app proxy prefix, so a canonical
 * URL built server-side could point at a path that does not exist.
 * `og:image` must be an absolute URL, so anything else is skipped.
 */
export function buildOpenGraphTags(
    landingPage: Pick<ApiShopperLandingPage, 'title' | 'imageUrl' | 'client'>,
): OpenGraphTag[] {
    const { client } = landingPage
    const candidates: Array<[string, string | undefined]> = [
        ['og:type', 'website'],
        ['og:title', landingPage.title?.trim() || client?.name],
        ['og:site_name', client?.displayName || client?.name],
        [
            'og:image',
            landingPage.imageUrl?.startsWith('https://')
                ? landingPage.imageUrl
                : undefined,
        ],
    ]
    return candidates.flatMap(([property, content]) =>
        content ? [{ property, content }] : [],
    )
}
